import { Selection } from '@atlaskit/editor-prosemirror/state';

import type {
	InsertNodeAfterCommand,
	StreamingCommandFactory,
} from '../aiStreamingOrchestratorPluginType';

import { findNodeByLocalId } from './utils/find-node-by-local-id';

export const createInsertNodeAfterCommand: StreamingCommandFactory<InsertNodeAfterCommand> =
	(api) => (command) => {
		api.core.actions.execute(({ tr }) => {
			findNodeByLocalId(tr, command.localId, ({ pos, node }) => {
				const $pos = tr.doc.resolve(Math.min(pos + node.nodeSize, tr.doc.content.size));
				// If forward fails try backward (ie. if we're at the end of the document)
				const selection = Selection.findFrom($pos, 1) ?? Selection.findFrom($pos, -1);
				if (!selection) {
					throw new Error('Selection not found');
				}
				if (command.value) {
					tr.setSelection(selection).insert(selection.anchor, command.value).scrollIntoView();
				} else {
					tr.setSelection(selection).scrollIntoView();
				}
			});
			return tr;
		});
		return true;
	};
